import {
  createBoundingBoxFromPoints,
  mergeOverlappingPolygons
} from '@/common/polygonUtils';

/**
 * Draws the ride plan on the whole-ride map: one area per day around that
 * day's places, overlapping days merged, in place of the stay markers. What
 * the summary's activities tab shows (ClassicTimeline), and so what a ride
 * with one stay or none opens on.
 *
 * Waits for the map if it is not ready yet; `stillWanted` is asked again
 * before a delayed draw, so a tab or design that changed meanwhile wins.
 */
export function drawRideDayAreas(store, stillWanted = () => true) {
  const { appMap, allRide } = store.getters;
  if (!appMap) {
    setTimeout(() => {
      if (stillWanted()) drawRideDayAreas(store, stillWanted);
    }, 500);
    return;
  }
  if (!allRide || !allRide.attractionsByDay) {
    return;
  }

  store.dispatch('removeAllMarkersFromGlobalMAp');
  store.dispatch('removeAllPolygonsFromGlobalMap');

  const dayPolygons = [];
  allRide.attractionsByDay.forEach((dailyActivities, dayIndex) => {
    const points = (dailyActivities.daily_attractions || [])
      .map(attraction => ({
        lat: parseFloat(attraction.latitude),
        lng: parseFloat(attraction.longtitude),
      }))
      .filter(point => point.lat && point.lng && !isNaN(point.lat) && !isNaN(point.lng));

    if (points.length === 0) {
      return;
    }

    let polygonPath;
    if (points.length === 1) {
      // A single place: a small square around it.
      const point = points[0];
      const padding = 0.005; // in degrees
      polygonPath = [
        { lat: point.lat + padding, lng: point.lng - padding },
        { lat: point.lat + padding, lng: point.lng + padding },
        { lat: point.lat - padding, lng: point.lng + padding },
        { lat: point.lat - padding, lng: point.lng - padding },
      ];
    } else {
      polygonPath = createBoundingBoxFromPoints(points, appMap);
    }

    dayPolygons.push({ polygonPath, dayNumber: dayIndex + 1, days: [dayIndex + 1] });
  });

  const firstDay = polygon => (polygon.days ? Math.min(...polygon.days) : polygon.dayNumber);
  // Earlier days drawn last, so they sit on top.
  mergeOverlappingPolygons(dayPolygons)
    .sort((a, b) => firstDay(a) - firstDay(b))
    .forEach(polygon => {
      store.dispatch('addPolygonToGlobalMap', {
        polygonPath: polygon.polygonPath,
        dayNumber: polygon.dayNumber,
        days: polygon.days,
        zIndex: firstDay(polygon),
      });
    });

  setTimeout(() => store.dispatch('fitBoundsToPolygons'));
}
